import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Form = styled.div`
  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};
  display: flex;
  justify-content: space-between;
  min-height: 75%;

  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
  }
`;

export const FormElements = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(32)};
  flex-grow: 1;
  flex-shrink: 1;
  min-width: ${rem(200)};
  padding-right: ${rem(32)};
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100%;
  border-left: 1px solid ${({ theme }) => theme.colors.gray600};
  padding: 0 ${rem(32)};
  flex-shrink: 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    border-left: none;
    padding: 0;
    margin-top: ${rem(16)};
  }

  button {
    margin: ${rem(16)};
    width: 100%;
  }
`;

export const H1 = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(24)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.gray800};
`;
